// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"481e1efb","131":"03bf515e","155":"460ef563","387":"d20544e2","530":"3bd801a2","730":"e42e5337","821":"1878e1f4","839":"cbef0591","858":"d2eb0074","937":"1f32af3c","941":"381ff6c6"}[chunkId] + ".chunk.css";
};